import { Flex, Link, SectionMessage, Space, Spacing, Text } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { TaxAi } from '../../../../../../../src/assets/images'
import { LocalStorageKeys } from '../../../../../../enums/localStorageKeys'
import { useClosableBanner } from '../../../../../../hooks/useClosableBanner'
import { SUGGESTIONS_SUPPORT_LINK } from '../../consts/suggestionsSupportLink'
import * as Styled from './styles'

export const PromoBanner = () => {
  const { t } = useTranslation()
  const { isClosed, close } = useClosableBanner(LocalStorageKeys.VatDeclarationsPromoBanner)

  if (isClosed) {
    return null
  }

  return (
    <>
      <SectionMessage variant="info" showIcon={false} closable onClose={close}>
        <Flex alignItems="center" gap={Spacing.S12}>
          <Styled.ImageWrapper>
            <TaxAi />
          </Styled.ImageWrapper>
          <Flex flexDirection="column" flexGrow={1}>
            <Text variant="h4">{t('copilot.promo_banner.title')}</Text>
            <Text>{t('copilot.promo_banner.text')}</Text>
            <Link href={SUGGESTIONS_SUPPORT_LINK} target="_blank">
              <Text weight="bold">{t('copilot.learn_more')}</Text>
            </Link>
          </Flex>
        </Flex>
      </SectionMessage>
      <Space />
    </>
  )
}
